import { createAsyncActionTypes } from '@mews/framework';
import prefix from '../prefix';

// These action types are placed into separate file to avoid webpack circular dependency issue's

export const CATEGORIES_FETCH = prefix('CATEGORIES_FETCH');
export const [CATEGORIES_FETCH_STARTED, CATEGORIES_FETCH_SUCCEEDED, CATEGORIES_FETCH_FAILED] =
    createAsyncActionTypes(CATEGORIES_FETCH);

export const CITIES_FETCH = prefix('CITIES_FETCH');
export const [CITIES_FETCH_STARTED, CITIES_FETCH_SUCCEEDED, CITIES_FETCH_FAILED] = createAsyncActionTypes(CITIES_FETCH);

export const RATES_FETCH = prefix('RATES_FETCH');
export const [RATES_FETCH_STARTED, RATES_FETCH_SUCCEEDED, RATES_FETCH_FAILED] = createAsyncActionTypes(RATES_FETCH);

export const RATES_DELETE = prefix('RATES_DELETE');
export const [RATES_DELETE_STARTED, RATES_DELETE_SUCCEEDED, RATES_DELETE_FAILED] = createAsyncActionTypes(RATES_DELETE);

export const RATE_GROUPS_FETCH = prefix('RATE_GROUPS_FETCH');
export const [RATE_GROUPS_FETCH_STARTED, RATE_GROUPS_FETCH_SUCCEEDED, RATE_GROUPS_FETCH_FAILED] =
    createAsyncActionTypes(RATE_GROUPS_FETCH);

export const SERVICE_FETCH = prefix('SERVICE_FETCH');
export const [SERVICE_FETCH_STARTED, SERVICE_FETCH_SUCCEEDED, SERVICE_FETCH_FAILED] =
    createAsyncActionTypes(SERVICE_FETCH);

export const PAYMENT_CARDS_FETCH = prefix('PAYMENT_CARDS_FETCH');
export const [PAYMENT_CARDS_FETCH_STARTED, PAYMENT_CARDS_FETCH_SUCCEEDED, PAYMENT_CARDS_FETCH_FAILED] =
    createAsyncActionTypes(PAYMENT_CARDS_FETCH);
